const areaData = [
    // 関東
    { name: "東京", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo" },
    { name: "東京 渋谷", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-shibuya" },
    { name: "東京 新宿", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-shinjuku" },
    { name: "東京 銀座", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-ginza" },
    { name: "東京 六本木", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-roppongi" },
    { name: "東京 池袋", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-ikebukuro" },
    { name: "東京 町田", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-machida" },
    { name: "東京 表参道", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-omotesando" },
    { name: "東京 恵比寿", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-ebisu" },
    { name: "東京 広尾", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-hiroo" },
    { name: "東京 練馬", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-nerima" },
    { name: "東京 自由が丘", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-jiyugaoka" },
    { name: "東京 立川", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-tachikawa" },
    { name: "東京 国分寺", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-kokubunji" },
    { name: "東京 北千住", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-kitasenju" },
    { name: "東京 吉祥寺", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-kichijouji" },
    { name: "東京 品川", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-shinagawa" },
    { name: "東京 浅草・蔵前", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tokyo-asakusa-kuramae" },
    { name: "神奈川", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/kanagawa" },
    { name: "神奈川 横浜", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/kanagawa-yokohama" },
    { name: "神奈川 川崎", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/kanagawa-kawasaki" },
    { name: "埼玉", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/saitama" },
    { name: "埼玉 大宮", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/saitama-omiya" },
    { name: "埼玉 浦和", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/saitama-urawa" },
    { name: "千葉", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/chiba" },
    { name: "千葉 柏", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/chiba-kashiwa" },
    { name: "千葉 松戸", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/chiba-mastudo" },
    { name: "群馬", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/gunma" },
    { name: "茨城", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/ibaraki" },
    { name: "栃木", region: "kanto", url: "https://ufit.co.jp/blogs/pilates/tochigi" },

    // 関西
    { name: "大阪", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/osaka-umeda" },
    { name: "大阪 梅田", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/osaka-umeda" },
    { name: "京都", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/kyoto" },
    { name: "兵庫", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/hyogo" },
    { name: "兵庫 神戸", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/hyogo-kobe" },
    { name: "滋賀", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/shiga" },
    { name: "奈良", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/nara" },
    { name: "和歌山", region: "kansai", url: "https://ufit.co.jp/blogs/pilates/wakayama" },

    // 中部
    { name: "愛知", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/aichi" },
    { name: "愛知 名古屋", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/aichi-nagoya" },
    { name: "静岡", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/shizuoka" },
    { name: "静岡 浜松", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/shizuoka-hamamastu" },
    { name: "岐阜", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/gifu" },
    { name: "三重", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/mie" },
    { name: "山梨", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/yamanashi" },
    { name: "長野", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/nagano" },
    { name: "新潟", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/niigata" },
    { name: "富山", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/toyama" },
    { name: "石川", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/ishikawa" },
    { name: "石川 金沢", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/ishikawa-kanazawa" },
    { name: "福井", region: "chubu", url: "https://ufit.co.jp/blogs/pilates/fukui" },

    // 中国
    { name: "岡山", region: "chugoku", url: "https://ufit.co.jp/blogs/pilates/okayama" },
    { name: "広島", region: "chugoku", url: "https://ufit.co.jp/blogs/pilates/hiroshima" },
    { name: "鳥取", region: "chugoku", url: "https://ufit.co.jp/blogs/pilates/tottori" },
    { name: "島根", region: "chugoku", url: "https://ufit.co.jp/blogs/pilates/shimane" },
    { name: "山口", region: "chugoku", url: "https://ufit.co.jp/blogs/pilates/yamaguchi" },

    // 四国
    { name: "徳島", region: "shikoku", url: "https://ufit.co.jp/blogs/pilates/tokushima" },
    { name: "香川", region: "shikoku", url: "https://ufit.co.jp/blogs/pilates/kagawa" },
    { name: "愛媛", region: "shikoku", url: "https://ufit.co.jp/blogs/pilates/ehime" },
    { name: "高知", region: "shikoku", url: "https://ufit.co.jp/blogs/pilates/kochi" },

    // 九州・沖縄
    { name: "福岡", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/fukuoka" },
    { name: "佐賀", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/saga" },
    { name: "長崎", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/nagasaki" },
    { name: "熊本", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/kumamoto" },
    { name: "大分", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/oita" },
    { name: "宮崎", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/miyazaki" },
    { name: "鹿児島", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/kagoshima" },
    { name: "沖縄", region: "kyushu", url: "https://ufit.co.jp/blogs/pilates/okinawa" },

    // 東北
    { name: "宮城 仙台", region: "tohoku", url: "https://ufit.co.jp/blogs/pilates/miyagi-sendai" },
    { name: "青森", region: "tohoku", url: "https://ufit.co.jp/blogs/pilates/aomori" },
    { name: "秋田", region: "tohoku", url: "https://ufit.co.jp/blogs/pilates/akita" },
    { name: "岩手", region: "tohoku", url: "https://ufit.co.jp/blogs/pilates/iwate" },
    { name: "山形", region: "tohoku", url: "https://ufit.co.jp/blogs/pilates/yamagata" },
    { name: "福島", region: "tohoku", url: "https://ufit.co.jp/blogs/pilates/fukushima" },

    // 北海道
    { name: "北海道", region: "hokkaido", url: "https://ufit.co.jp/blogs/pilates/hokkaido" },
    { name: "北海道 札幌", region: "hokkaido", url: "https://ufit.co.jp/blogs/pilates/hokkaido-sapporo" }
];

// 地域ごとの都道府県データ
const prefecturesByRegion = {
    hokkaido: [
        { name: '北海道', url: 'https://ufit.co.jp/blogs/pilates/hokkaido' },
        { name: '札幌', url: 'https://ufit.co.jp/blogs/pilates/hokkaido-sapporo' }
    ],
    tohoku: [
        { name: '青森', url: 'https://ufit.co.jp/blogs/pilates/aomori' },
        { name: '秋田', url: 'https://ufit.co.jp/blogs/pilates/akita' },
        { name: '岩手', url: 'https://ufit.co.jp/blogs/pilates/iwate' },
        { name: '宮城', url: 'https://ufit.co.jp/blogs/pilates/miyagi-sendai' },
        { name: '山形', url: 'https://ufit.co.jp/blogs/pilates/yamagata' },
        { name: '福島', url: 'https://ufit.co.jp/blogs/pilates/fukushima' }
    ],
    kanto: [
        {
            name: '東京',
            url: 'https://ufit.co.jp/blogs/pilates/tokyo',
            subAreas: [
                { name: '東京', url: 'https://ufit.co.jp/blogs/pilates/tokyo' },
                { name: '渋谷', url: 'https://ufit.co.jp/blogs/pilates/tokyo-shibuya' },
                { name: '新宿', url: 'https://ufit.co.jp/blogs/pilates/tokyo-shinjuku' },
                { name: '銀座', url: 'https://ufit.co.jp/blogs/pilates/tokyo-ginza' },
                { name: '六本木', url: 'https://ufit.co.jp/blogs/pilates/tokyo-roppongi' },
                { name: '池袋', url: 'https://ufit.co.jp/blogs/pilates/tokyo-ikebukuro' },
                { name: '町田', url: 'https://ufit.co.jp/blogs/pilates/tokyo-machida' },
                { name: '表参道', url: 'https://ufit.co.jp/blogs/pilates/tokyo-omotesando' },
                { name: '恵比寿', url: 'https://ufit.co.jp/blogs/pilates/tokyo-ebisu' },
                { name: '広尾', url: 'https://ufit.co.jp/blogs/pilates/tokyo-hiroo' },
                { name: '練馬', url: 'https://ufit.co.jp/blogs/pilates/tokyo-nerima' },
                { name: '自由が丘', url: 'https://ufit.co.jp/blogs/pilates/tokyo-jiyugaoka' },
                { name: '立川', url: 'https://ufit.co.jp/blogs/pilates/tokyo-tachikawa' },
                { name: '国分寺', url: 'https://ufit.co.jp/blogs/pilates/tokyo-kokubunji' },
                { name: '北千住', url: 'https://ufit.co.jp/blogs/pilates/tokyo-kitasenju' },
                { name: '吉祥寺', url: 'https://ufit.co.jp/blogs/pilates/tokyo-kichijouji' },
                { name: "品川", url: "https://ufit.co.jp/blogs/pilates/tokyo-shinagawa" },
                { name: "浅草・蔵前", url: "https://ufit.co.jp/blogs/pilates/tokyo-asakusa-kuramae" }
            ]
        },
        {
            name: '神奈川',
            url: 'https://ufit.co.jp/blogs/pilates/kanagawa',
            subAreas: [
                { name: '横浜', url: 'https://ufit.co.jp/blogs/pilates/kanagawa-yokohama' },
                { name: '川崎', url: 'https://ufit.co.jp/blogs/pilates/kanagawa-kawasaki' }
            ]
        },
        {
            name: '埼玉',
            url: 'https://ufit.co.jp/blogs/pilates/saitama',
            subAreas: [
                { name: '埼玉', url: 'https://ufit.co.jp/blogs/pilates/saitama' },
                { name: '大宮', url: 'https://ufit.co.jp/blogs/pilates/saitama-omiya' },
                { name: '浦和', url: 'https://ufit.co.jp/blogs/pilates/saitama-urawa' }
            ]
        },
        {
            name: '千葉',
            url: 'https://ufit.co.jp/blogs/pilates/chiba',
            subAreas: [
                { name: '千葉', url: 'https://ufit.co.jp/blogs/pilates/chiba' },
                { name: '柏', url: 'https://ufit.co.jp/blogs/pilates/chiba-kashiwa' },
                { name: '松戸', url: 'https://ufit.co.jp/blogs/pilates/chiba-mastudo' }
            ]
        },
        { name: '群馬', url: 'https://ufit.co.jp/blogs/pilates/gunma' },
        { name: '茨城', url: 'https://ufit.co.jp/blogs/pilates/ibaraki' },
        { name: '栃木', url: 'https://ufit.co.jp/blogs/pilates/tochigi' }
    ],
    chubu: [
        {
            name: '愛知',
            url: 'https://ufit.co.jp/blogs/pilates/aichi',
            subAreas: [
                { name: '愛知', url: 'https://ufit.co.jp/blogs/pilates/aichi' },
                { name: '名古屋', url: 'https://ufit.co.jp/blogs/pilates/aichi-nagoya' }
            ]
        },
        {
            name: '静岡',
            url: 'https://ufit.co.jp/blogs/pilates/shizuoka',
            subAreas: [
                { name: '静岡', url: 'https://ufit.co.jp/blogs/pilates/shizuoka' },
                { name: '浜松', url: 'https://ufit.co.jp/blogs/pilates/shizuoka-hamamastu' }
            ]
        },
        { name: '岐阜', url: 'https://ufit.co.jp/blogs/pilates/gifu' },
        { name: '三重', url: 'https://ufit.co.jp/blogs/pilates/mie' },
        { name: '山梨', url: 'https://ufit.co.jp/blogs/pilates/yamanashi' },
        { name: '長野', url: 'https://ufit.co.jp/blogs/pilates/nagano' },
        { name: '新潟', url: 'https://ufit.co.jp/blogs/pilates/niigata' },
        { name: '富山', url: 'https://ufit.co.jp/blogs/pilates/toyama' },
        {
            name: '石川',
            url: 'https://ufit.co.jp/blogs/pilates/ishikawa',
            subAreas: [
                { name: '石川', url: 'https://ufit.co.jp/blogs/pilates/ishikawa' },
                { name: '金沢', url: 'https://ufit.co.jp/blogs/pilates/ishikawa-kanazawa' }
            ]
        },
        { name: '福井', url: 'https://ufit.co.jp/blogs/pilates/fukui' }
    ],
    kansai: [
        {
            name: '大阪',
            url: 'https://ufit.co.jp/blogs/pilates/osaka-umeda',
            subAreas: [
                { name: '大阪', url: 'https://ufit.co.jp/blogs/pilates/osaka-umeda' },
                { name: '梅田', url: 'https://ufit.co.jp/blogs/pilates/osaka-umeda' }
            ]
        },
        { name: '京都', url: 'https://ufit.co.jp/blogs/pilates/kyoto' },
        {
            name: '兵庫',
            url: 'https://ufit.co.jp/blogs/pilates/hyogo',
            subAreas: [
                { name: '兵庫', url: 'https://ufit.co.jp/blogs/pilates/hyogo' },
                { name: '神戸', url: 'https://ufit.co.jp/blogs/pilates/hyogo-kobe' }
            ]
        },
        { name: '滋賀', url: 'https://ufit.co.jp/blogs/pilates/shiga' },
        { name: '奈良', url: 'https://ufit.co.jp/blogs/pilates/nara' },
        { name: '和歌山', url: 'https://ufit.co.jp/blogs/pilates/wakayama' }
    ],
    chugoku: [
        { name: '岡山', url: 'https://ufit.co.jp/blogs/pilates/okayama' },
        { name: '広島', url: 'https://ufit.co.jp/blogs/pilates/hiroshima' },
        { name: '鳥取', url: 'https://ufit.co.jp/blogs/pilates/tottori' },
        { name: '島根', url: 'https://ufit.co.jp/blogs/pilates/shimane' },
        { name: '山口', url: 'https://ufit.co.jp/blogs/pilates/yamaguchi' }
    ],
    shikoku: [
        { name: '徳島', url: 'https://ufit.co.jp/blogs/pilates/tokushima' },
        { name: '香川', url: 'https://ufit.co.jp/blogs/pilates/kagawa' },
        { name: '愛媛', url: 'https://ufit.co.jp/blogs/pilates/ehime' },
        { name: '高知', url: 'https://ufit.co.jp/blogs/pilates/kochi' }
    ],
    kyushu: [
        { name: '福岡', url: 'https://ufit.co.jp/blogs/pilates/fukuoka' },
        { name: '佐賀', url: 'https://ufit.co.jp/blogs/pilates/saga' },
        { name: '長崎', url: 'https://ufit.co.jp/blogs/pilates/nagasaki' },
        { name: '熊本', url: 'https://ufit.co.jp/blogs/pilates/kumamoto' },
        { name: '大分', url: 'https://ufit.co.jp/blogs/pilates/oita' },
        { name: '宮崎', url: 'https://ufit.co.jp/blogs/pilates/miyazaki' },
        { name: '鹿児島', url: 'https://ufit.co.jp/blogs/pilates/kagoshima' },
        { name: '沖縄', url: 'https://ufit.co.jp/blogs/pilates/okinawa' }
    ]
}; 